import * as types from "./../types";

const state = {
  ordersData: []
};

const getters = {
  [types.order.getters.GET_ORDERS_DATA]: state => {
    return state.ordersData;
  }
};

const mutations = {
  [types.order.mutations.MUTATE_ORDERS_DATA]: (state, payload) => {
    state.ordersData = payload;
  },
  [types.order.mutations.UPDATE_ORDERS_DATA]: (state, payload) => {
    state.ordersData.data.find(el => {
      if (el.reference_number === payload.reference_number) {
        el.status = payload.status;
        el.status_locale = payload.status_locale;
        el.is_cancelable = payload.is_cancelable;
      }
    });
  }
};

const actions = {
  [types.order.actions.SET_ORDERS_DATA]: ({ commit }, payload) => {
    commit(types.order.mutations.MUTATE_ORDERS_DATA, payload);
  },
  [types.order.actions.UPDATE_ORDERS_DATA]: ({ commit }, payload) => {
    commit(types.order.mutations.UPDATE_ORDERS_DATA, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
